import { AnaColumn } from "../forms-template.service";

export const CrmProcedureDetail: AnaColumn[] = [

  {
    configuration:
    {
      queryString: '',
      service: 'CrmProcedureDetailForm',
      api: 'getmasterprocedure',
      api_rest: true,
      widthForm: '800'
    },
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'CodContatto',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice Contatto',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'CodSede',
        colVisible: true,
        dataType: 'string',
        caption: 'Sede',
        colAlignment: 'left',
        lookup: {
          dataSource: 'sede',
          valueExpr: 'Cod',
          displayExpr: 'Ind',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodProcedura',
        colVisible: true,
        dataType: 'string',
        caption: 'Sigla Procedura',
        allowFiltering: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lookup: {
          dataSource: 'procedure',
          valueExpr: 'Cod',
          displayExpr: 'Sigla',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodProcedura',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione',
        allowFiltering: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lookup: {
          dataSource: 'procedure',
          valueExpr: 'Cod',
          displayExpr: 'Des',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice Modulo',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        allowFiltering: false,
      },
      {
        type: 'campo',
        dataField: 'id_master_procedura',
        colVisible: false,
        dataType: 'string',
        caption: 'id_master_procedura',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'keycode',
        colVisible: true,
        dataType: 'string',
        caption: 'Codice Attivazione',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'dataAttivazione',
        colVisible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        caption: 'Data Inizio Fatturazione',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'dataScadenza',
        colVisible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        caption: 'Data Fine Fatturazione',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'nota',
        colVisible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'left',

      },
      {
        type: 'campo',
        dataField: 'quantita',
        colVisible: true,
        dataType: 'string',
        caption: 'Quantità',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'isModulo',
        colVisible: false,
        dataType: 'string',
        caption: 'isModulo',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'accettaModuli',
        colVisible: true,
        dataType: 'boolean',
        caption: 'Accetta Mod.',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'procedura_attiva',
        colVisible: true,
        dataType: 'boolean',
        caption: 'Attiva',
        colAlignment: 'center',
      },
    ]
  },

]

export const CrmProcedureMasterDetail: AnaColumn[] = [

  {
    configuration:
    {
      masterKey: 'id',
      filterEditor: '/$',
      queryString: '',
      service: 'CrmProcedureMasterDetailForm',
      api: 'getmasterprocedure',
      api_rest: true,
      widthForm: '440'

    },
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '1',
    data: [
      {
        type: 'campo',
        dataField: 'id',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'CodContatto',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice Contatto',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'CodSede',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice Sede',
        colAlignment: 'left',
        lookup: {
          dataSource: 'sede',
          valueExpr: 'Cod',
          displayExpr: 'Ind',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodProcedura',
        colVisible: false,
        dataType: 'string',
        caption: 'Codice Procedura',
        allowFiltering: false,
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        lookup: {
          dataSource: 'procedure',
          valueExpr: 'Cod',
          displayExpr: 'Sigla',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        colVisible: true,
        dataType: 'string',
        caption: 'Sigla Modulo',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        allowFiltering: false,
        lookup: {
          dataSource: 'procedure',
          valueExpr: 'Cod',
          displayExpr: 'Sigla',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        colVisible: true,
        dataType: 'string',
        caption: 'Descrizione Modulo',
        colAlignment: 'left',
        editorType: 'dxSelectBox',
        allowFiltering: false,
        lookup: {
          dataSource: 'procedure',
          valueExpr: 'Cod',
          displayExpr: 'Des',
          colonne: [{
            dataField: 'Ind'
          }]
        }
      },
      {
        type: 'campo',
        dataField: 'id_master_procedura',
        colVisible: false,
        dataType: 'string',
        caption: 'id_master_procedura',
        colAlignment: 'center',
      },

      {
        type: 'campo',
        dataField: 'dataAttivazione',
        colVisible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: 'dxDateBox',
        caption: 'Data Inizio Fatturazione',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'dataScadenza',
        colVisible: false,
        format: "dd/MM/yyyy",
        editorType: 'dxDateBox',
        dataType: 'date',
        caption: 'Data Fine Fatturazione',
        colAlignment: 'center',
      },
      /*       {
              type: 'campo',
              dataField: 'id_master_procedura',
              colVisible: true,
              dataType: 'date',
              format: "dd/MM/yyyy",
              editorType: 'dxDateBox',
              caption: 'Data Fine Fatturazione',
              colAlignment: 'center',
              allowFiltering: false,
              lookup: {
                dataSource: 'getmasterprocedure',
                valueExpr: 'id',
                displayExpr: 'dataScadenza',
                colonne: [{
                  dataField: 'Ind'
                }]
              }
            }, */

      {
        type: 'campo',
        dataField: 'keycode',
        colVisible: false,
        dataType: 'string',
        caption: 'keycode',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'Des',
        colVisible: false,
        dataType: 'string',
        caption: 'Descrizione',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'nota',
        colVisible: true,
        dataType: 'string',
        caption: 'Note',
        colAlignment: 'center',

      },

      {
        type: 'campo',
        dataField: 'quantita',
        colVisible: true,
        dataType: 'string',
        caption: 'Quantità',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'isModulo',
        colVisible: false,
        dataType: 'string',
        caption: 'isModulo',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'accettaModuli',
        colVisible: false,
        dataType: 'boolean',
        caption: 'Accetta Mod.',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'procedura_attiva',
        colVisible: true,
        dataType: 'boolean',
        caption: 'Attivo',
        colAlignment: 'center',
      },
    ]
  },

]

export const CrmProcedureDetailForm: AnaColumn[] = [


  {
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '7',

    data: [
      {
        type: 'campo',
        dataField: 'id',
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodContatto',
        visible: false,
        dataType: 'string',
        caption: 'Codice Contatto',
        colAlignment: 'center',
      },
      /*  */
      {
        type: 'campo',
        dataField: 'CodSede',
        visible: true,
        dataType: 'string',
        caption: 'Sede',
        disableOnUpdate: true,
        nCol: 10,
        class: 'crm_editor',
        colAlignment: 'center',
        validation: [
          { type: "required", message: "Campo Sede obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?CodiceContatto=$CodContatto',
          costantValue: [
            { key: 'CodContatto', value: 'CodContatto' },
          ],
          displayExpr: 'Ind',
          filter: '',
          dataSource: 'sede',
          service: '',
          autocomplete: false,
          caption: 'Lista Sedi',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Sedi',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: false, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'RagSoc',
                dataType: '',
                caption: 'RagSoc',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'Ind',
                dataType: '',
                caption: 'Indirizzo',
                allowEditing: true,
              },
              {
                dataField: 'Cap',
                dataType: '',
                caption: 'Cap',
                allowEditing: true,
              },
              {
                type: 'campo',
                dataField: 'id_localita',
                dataType: 'string',
                caption: 'Comune',
                colAlignment: 'left',
                width: 80,
                lista: {
                  wingap: false,
                  dataSource: 'comuni',
                  valueExpr: 'id',
                  displayExpr: 'nome',
                }
              },
              {
                type: 'campo',
                dataField: 'id_provincia',
                dataType: 'string',
                caption: 'Provincia',
                colAlignment: 'left',
                width: 80,
                lista: {
                  wingap: false,
                  dataSource: 'province',
                  valueExpr: 'id',
                  displayExpr: 'nome',
                }
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      /* ---------------------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'CodProcedura',
        visible: true,
        dataType: 'string',
        showClearButton: false,
        disableOnUpdate: true,
        caption: 'Procedura Principale',
        class: 'crm_editor',
        colAlignment: 'center',
        nCol: 10,
        validation: [
          { type: "required", message: "Campo Procedura obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?isModulo=0&Block=0',
          displayExpr: 'Des',
          campoTabRif: 'id',
          related: ['Des|Des', 'Licenza|Licenza', 'Assistenza|Assistenza', '|RateoIniziale'],
          dataSource: 'procedure',
          service: '',
          autocomplete: false,
          caption: 'Lista Procedure',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Procedure',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,

            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            //width: 800,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false,
                colWidth: '10',
                width: 10,
              },
              {
                dataField: 'Sigla',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
                width: 20,
                colWidth: '20'
              },
              {
                dataField: 'Des',
                dataType: '',
                caption: 'Descrizione Procedura',
                allowEditing: true,
                colAlignment: 'left',
                width: 60,
                colWidth: '60'
              },
              {
                type: 'campoSpecial',
                dataField: 'accettaModuli',
                dataType: 'number',

                caption: 'Accetta Moduli',
                colAlignment: 'center',
                allowEditing: true,
                width: 20,
                colWidth: '20',
                lista: {
                  valueExpr: 'id',
                  displayExpr: 'value',
                  dataSource: 'accettaModuli',
                  static: true,
                }
              },

            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      /* ***************************************************************************** */
      {
        type: 'campo',
        dataField: 'keycode',
        visible: true,
        dataType: 'string',
        class: 'crm_editor',
        caption: 'Codice Attivazione',
        nCol: 10,
        colAlignment: 'center',
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Licenza',
        visible: true,
        dataType: 'number',
        caption: 'Licenza',
        colAlignment: 'left',
        nCol: 2,
        class: 'crm_editor',
      },
      {
        type: 'campo',
        dataField: 'Assistenza',
        visible: true,
        dataType: 'number',
        caption: 'Assistenza',
        colAlignment: 'left',
        nCol: 2,
        class: 'crm_editor',
      },
      {
        type: 'campo',
        dataField: 'quantita',
        visible: false,
        class: 'crm_editor',
        editorType: 'dxNumberBox',
        dataType: 'number',
        nCol: 4,
        minLength: "1", maxLength: "2",
        showClearButton: false,
        caption: 'Quantità',
        colAlignment: 'center',
      },
      /********************************* */
      /*
      {
        type: 'campo',
        dataField: 'RateoIniziale',
        caption: 'Rateo Iniziale',
        class: 'crm_editor me-auto',
        nCol: 2,
        button: {
          name: 'btnCalcola',
          hint: 'Calcola',
          icon: 'bi bi-calculator',
          text: '',
          type: 'normal',
          stylingMode: 'contain',
          event: 'btnCalcola',
          disabled: false,
          class: '',
          visible: true,
        }
      },
      {
        type: 'campo',
        dataField: 'rate',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'rata1',
        caption: 'Rate',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata2',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata3',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata4',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      */
      /* ---------------------------------------------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Des',
        visible: false,
        dataType: 'string',
        editorType: 'dxTextArea',
        disabled: true,
        class: 'disabileVisibile',
        caption: 'Descrizione Procedura',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        visible: false,
        dataType: 'string',
        caption: 'Codice Modulo',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'id_master_procedura',
        visible: false,
        dataType: 'string',
        caption: 'id_master_procedura',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'procedura_attiva',
        visible: true,
        defaultValue: 1,
        placeHolder: '1',
        dataType: 'number',
        editorType: 'dxSelectBox',
        class: 'crm_editor',
        caption: 'Stato',
        nCol: 4,
        validation: [
          { type: "required", message: "Campo Stato obbligatorio" },
        ],
        lista: {
          isDefaultOption: false,
          dataSource: '',
          searchEnable: false,
          valueExpr: 'key',
          displayExpr: 'value',
          static: true,
          items: [
            { key: 0, value: 'Disattivo' },
            { key: 1, value: 'Attivo' },
            // { key: 2, value: 'In Approvazione' },
            { key: 3, value: 'Disdetta' }
          ]
        }

      },
      {
        type: 'campo',
        dataField: 'Motivazione',
        visible: true,
        dataType: 'string',
        caption: 'Motivazione Stato',
        disableOnUpdate: true,
        nCol: 6,
        class: 'crm_editor',
        colAlignment: 'center',
        dynamic: {
          valueExpr: 'id',
          queryString: '?tipo=23',
          costantValue: [],
          displayExpr: 'descrizione',
          filter: '',
          dataSource: 'tabella',
          service: '',
          autocomplete: false,
          caption: 'Lista Motivazioni',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Motivazioni',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: false, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'id',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
                colVisible: true
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'dataInstallazione',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        class: 'crm_editor disabileVisibile',
        editorType: "dxDateBox",
        disableOnUpdate: true,
        disabled: true,
        showClearButton: false,
        nCol: 2,
        showDropDownButton: false,
        caption: 'Data Installazione',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'dataAttivazione',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        class: 'crm_editor',
        nCol: 2,
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Inizio Validità',
        colAlignment: 'center',
        validation: [
          { type: "required", message: "Campo Data Inizio Validità obbligatorio" },
        ],
      },
      {
        type: 'campo',
        dataField: 'dataScadenza',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        class: 'crm_editor',
        editorType: "dxDateBox",
        showClearButton: true,
        nCol: 2,
        showDropDownButton: true,
        caption: 'Data Fine Validità',
        colAlignment: 'center',
        validation: [
          { type: "required", message: "Campo Data Fine Validità obbligatorio" },
        ],
      },
      {
        type: 'campo',
        dataField: 'dataEsecuzione',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        class: 'crm_editor',
        editorType: "dxDateBox",
        showClearButton: true,
        nCol: 2,
        showDropDownButton: true,
        caption: 'Data Esecuzione',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'escludiContratto',
        dataType: 'boolean',
        caption: 'Escludi da stampa',
        editorType: 'dxSwitchBox',
        class: 'h-100 d-flex',
        nCol: 2,
        disabled: false,
        switchBox: {
          trueValue: 1,
          falseValue: 0,
          defaultValue: 0,
          switchedOnText: 'Si',
          switchedOffText: 'No',
          height: 24,
        }
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'rate',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'rata1',
        caption: 'Rate',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata2',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata3',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      {
        type: 'campo',
        dataField: 'rata4',
        dataType: 'number',
        editorType: 'dxNumberBox',
        showClearButton: false,
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 1
      },
      // { type: 'empty' },
      // { type: 'empty' },
      // { type: 'empty' },
      // { type: 'empty' },
      // { type: 'empty' },

      //----------------------------------------------------------------
      {
        nCol: 4,
        class: 'crm_editor',
        type: 'campo',
        dataField: 'fonte',
        colVisible: true,
        visible: true,
        dataType: 'number',
        caption: 'Fonte',
        colAlignment: 'left',
        //width: 320,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=22",
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 22 }
          ]
        }
      },
      // { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'nota',
        visible: true,
        dataType: 'string',
        caption: 'Note',
        class: 'crm_editor ann-height',
        editorType: "dxTextArea",
        nCol: 10,
        colAlignment: 'center',
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },

    ]
  }
]


export const CrmProcedureMasterDetailForm: AnaColumn[] = [
  {
    itemType: 'group',
    caption: '',
    class: '',
    colCount: '5',
    data: [
      {
        type: 'campo',
        dataField: 'id',
        visible: false,
        dataType: 'string',
        caption: 'Codice ID',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodContatto',
        visible: false,
        dataType: 'string',
        caption: 'Codice Contatto',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'CodSede',
        visible: false,
        dataType: 'string',
        caption: 'Sede',
        disableOnUpdate: true,
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'CodProcedura',
        visible: false,
        dataType: 'string',
        showClearButton: false,
        caption: 'Procedura',
        colAlignment: 'center',

      },
      {
        type: 'campo',
        dataField: 'CodModulo',
        visible: true,
        dataType: 'string',
        caption: 'Procedura Opzionale',
        showClearButton: false,
        disableOnUpdate: true,
        colAlignment: 'center',
        class: 'crm_editor',
        nCol: 10,
        validation: [
          { type: "required", message: "Campo Modulo obbligatorio" },
        ],
        dynamic: {
          valueExpr: 'Cod',
          queryString: '?isModulo=1&Block=0',
          displayExpr: 'Des',
          filter: '',
          dataSource: 'procedure',
          related: ['Des|Des', 'Licenza|Licenza', 'Assistenza|Assistenza'],
          service: '',
          autocomplete: false,
          caption: 'Lista Procedure',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Procedure',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'Cod',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'Cod',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'Sigla',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
              },
              {
                dataField: 'Des',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      /* ---------------------------------------------------------------- */
      {
        type: 'campo',
        dataField: 'Licenza',
        visible: true,
        dataType: 'number',
        caption: 'Licenza',
        colAlignment: 'left',
        class: 'crm_editor',
        nCol: 3,
      },
      {
        type: 'campo',
        dataField: 'Assistenza',
        visible: true,
        dataType: 'number',
        caption: 'Assistenza',
        colAlignment: 'left',
        class: 'crm_editor',
        nCol: 3
      },
      {
        type: 'campo',
        dataField: 'quantita',
        visible: true,
        editorType: 'dxNumberBox',
        dataType: 'number',
        class: 'crm_editor',
        minLength: '1',
        maxLength: '10',
        showClearButton: false,
        validation: [
          { type: "required", message: "Campo Quantità obbligatorio" },
          /*           { type: "pattern", value: '([1-9]|1[0-9]|20)', message: "Pattern errato" }, */
          { type: "min", value: 1, message: "Quantità minima consentita 1" },
          // { type: "max", value: 20, message: "Quantità massima consentita 20" },
          /*           { type: 'minLength', value: 2, message: "minLength errato" },
                    { type: 'maxLength', value: 2, message: "maxLength errato" }, */
        ],
        caption: 'Quantità',
        colAlignment: 'center',
        nCol: 4
      },
      { type: 'empty' },
      { type: 'empty' },
      /* ---------------------------------------------------------------------------------------------------- */
      /*
      {
        type: 'campo',
        dataField: 'RateoIniziale',
        caption: 'Rateo Iniziale',
        class: 'crm_editor me-auto',
        nCol: 4,
        button: {
          name: 'btnCalcola',
          hint: 'Calcola',
          icon: 'bi bi-calculator',
          text: '',
          type: 'normal',
          stylingMode: 'contain',
          event: 'btnCalcola',
          disabled: false,
          class: '',
          visible: true,
        }
      },
      {
        type: 'campo',
        dataField: 'rate',
        visible: false
      },
      {
        type: 'campo',
        dataField: 'rata1',
        caption: 'Rate',
        dataType: 'number',
        editorType: 'dxNumberBox',
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],

        class: 'crm_editor ms-auto',
        nCol: 2
      },
      {
        type: 'campo',
        dataField: 'rata2',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 2
      },
      {
        type: 'campo',
        dataField: 'rata3',
        caption: '',
        dataType: 'number',
        editorType: 'dxNumberBox',
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 2
      },
      {
        type: 'campo',
        dataField: 'rata4',
        dataType: 'number',
        editorType: 'dxNumberBox',
        maxLength: 2,
        validation: [
          { type: "min", value: 1, message: "Il valore delle rate può essere da 1 a 12" },
          { type: "max", value: 12, message: "Il valore delle rate può essere da 1 a 12" },
        ],
        class: 'crm_editor ms-auto',
        nCol: 2
      },
      */
      /*  */
      {
        type: 'campo',
        dataField: 'procedura_attiva',
        visible: true,
        defaultValue: 1,
        placeHolder: '1',
        dataType: 'boolean',
        editorType: 'dxSelectBox',
        class: 'crm_editor',
        caption: 'Stato',
        nCol: 3,
        validation: [
          { type: "required", message: "Campo Stato obbligatorio" },
        ],
        lista: {
          isDefaultOption: false,
          dataSource: '',
          searchEnable: false,
          valueExpr: 'key',
          displayExpr: 'value',
          static: true,
          items: [
            { key: 0, value: 'Disattivo' },
            { key: 1, value: 'Attivo' },
            { key: 2, value: 'In Attesa' }
          ]
        }

      },
      {
        type: 'campo',
        dataField: 'Motivazione',
        visible: true,
        dataType: 'string',
        disableOnUpdate: true,
        class: 'crm_editor',
        caption: 'Motivazione Stato',
        nCol: 7,
        dynamic: {
          valueExpr: 'id',
          queryString: '?tipo=23',
          costantValue: [],
          displayExpr: 'descrizione',
          filter: '',
          dataSource: 'tabella',
          service: '',
          autocomplete: false,
          caption: 'Lista Motivazioni',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Motivazioni',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: false, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'id',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'Descrizione',
                allowEditing: true,
                colVisible: true
              },
            ],
          },
        },
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'id_master_procedura',
        visible: false,
        dataType: 'string',
        caption: 'id_master_procedura',
        colAlignment: 'center',
      },

      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'dataInstallazione',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        class: 'crm_editor disabileVisibile',
        editorType: "dxDateBox",
        disableOnUpdate: true,
        disabled: true,
        showClearButton: false,
        nCol: 5,
        showDropDownButton: false,
        caption: 'Data Installazione',
        colAlignment: 'center',
      },
      {
        type: 'campoData',
        dataField: 'dataAttivazione',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Inizio Fatturazione',
        colAlignment: 'center',
        class: 'crm_editor',
        nCol: 5,
        validation: [
          { type: "required", message: "Campo Data Inizio Fatturazione obbligatorio" },
        ],
      },
      {
        type: 'campo',
        dataField: 'dataScadenza',
        visible: true,
        dataType: 'date',
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        showClearButton: true,
        showDropDownButton: true,
        caption: 'Data Fine Fatturazione',
        colAlignment: 'center',
        class: 'crm_editor',
        nCol: 5,
        validation: [
          { type: "required", message: "Campo Data Fine Fatturazione obbligatorio" },
        ],
      },
      { type: 'empty' },
      { type: 'empty' },

      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'keycode',
        visible: false,
        dataType: 'string',
        caption: 'keycode',
        colAlignment: 'center',
        class: 'crm_editor',
        nCol: 5
      },
      //----------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'escludiContratto',
        dataType: 'boolean',
        caption: 'Escludi da stampa',
        editorType: 'dxSwitchBox',
        class: 'h-100 d-flex',
        nCol: 4,
        disabled: false,
        switchBox: {
          trueValue: 1,
          falseValue: 0,
          defaultValue: 0,
          switchedOnText: 'Si',
          switchedOffText: 'No',
          height: 24
        }
      },
      {
        nCol: 6,
        class: 'h-100 d-flex',
        type: 'campo',
        dataField: 'fonte',
        colVisible: true,
        visible: true,
        dataType: 'number',
        caption: 'Fonte',
        colAlignment: 'left',
        //width: 320,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: "tabella",
          queryString: "?tipo=22",
          displayExpr: 'descrizione',
          valueExpr: 'id',
          wingap: false,
          static: false,
          costantValues: [
            { key: 'tipo', value: 22 }
          ]
        }
      },

      //{ type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      {
        type: 'campo',
        dataField: 'nota',
        visible: true,
        dataType: 'string',
        caption: 'Note',
        editorType: "dxTextArea",
        colAlignment: 'center',
        class: 'crm_editor ann-height',
        nCol: 10
      },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },
      { type: 'empty' },

      //----------------------------------------------------------------
    ]
  }
]